<template>
  <div data-app id="app">
    <router-view />
    <SmartInactivityTimer />
    <SmartModal v-if="modal" v-bind="modal" @close="forget">
      {{ modal.text }}
    </SmartModal>
  </div>
</template>
<script>
import SmartInactivityTimer from "packages/SmartInactivityTimer/SmartInactivityTimer.vue";
import { eventBus } from '@/main';

export default {
  data() {
    return {
      modal: null
    };
  },
  components: { SmartInactivityTimer },
  name: "Home",
  methods: {
    forget() {
      this.modal = null;
      localStorage.removeItem("token");
      this.$router.push({ path: "/" });
      this.$router.go();
    },
  },
  created() {
    eventBus.$on('event-bus-multiple-sessions', (message) => {
      this.modal = {
        type: "warning",
        title: "Atenção!",
        icon: "alert",
        buttonText: "Ok",
        text: message,
      };
    });
  },
};
</script>
